let handler;

const setHandler = (_handler) => {
  handler = _handler;
};

const success = (text, options) => {
  handler('success', text, options);
};

const error = (text, options) => {
  handler('error', text, options);
};

const warning = (text, options) => {
  handler('warning', text, options);
};

export { setHandler };

// eslint-disable-next-line import/no-anonymous-default-export
export default { success, error, warning };
